// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Employees page + AddEditEmployees modal.
   NOTE: AddEditEmployees is rendered across the app, so this file is effectively global.
   The rules under "Shared legacy helpers" are used by many other pages and should move to
   a shared stylesheet (see report); keep them until then.
   ============================================================ */

/* ── Employees (page-specific) ──────────────────────────────── */
.AddEmployees .addBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--ds-space-2);
}

.AddEmployees button {
  cursor: pointer;
}

.AddEmployees .employee-upload-button {
  border: 0;
  background: none;
  min-width: var(--ds-touch);
  min-height: var(--ds-touch);
  color: var(--ds-text-2);
}

.AddEmployees .employee-upload-button__label {
  margin-block-start: var(--ds-space-2);
}

/* ── Shared legacy helpers (used by other pages) ────────────── */
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/employees/Employees.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE,kEAAkE;AAClE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,kEAAkE","sourcesContent":["/* ============================================================\n   Employees page + AddEditEmployees modal.\n   NOTE: AddEditEmployees is rendered across the app, so this file is effectively global.\n   The rules under \"Shared legacy helpers\" are used by many other pages and should move to\n   a shared stylesheet (see report); keep them until then.\n   ============================================================ */\n\n/* ── Employees (page-specific) ──────────────────────────────── */\n.AddEmployees .addBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--ds-space-2);\n}\n\n.AddEmployees button {\n  cursor: pointer;\n}\n\n.AddEmployees .employee-upload-button {\n  border: 0;\n  background: none;\n  min-width: var(--ds-touch);\n  min-height: var(--ds-touch);\n  color: var(--ds-text-2);\n}\n\n.AddEmployees .employee-upload-button__label {\n  margin-block-start: var(--ds-space-2);\n}\n\n/* ── Shared legacy helpers (used by other pages) ────────────── */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
